import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetOrderHeadMiParams, OrderHeadMiGet, OrderheadService } from '@app/services/orderhead.service';

@Component({
    selector: 'tt-order-head-mi',
    templateUrl: './order-head-mi.component.html',
    styleUrls: ['./order-head-mi.component.css'],
})
export class OrderHeadMiComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetOrderHeadMiParams;

    @Output()
    public submit = new EventEmitter<void>();

    public get?: OrderHeadMiGet;

    public grid?: GridOptions;

    public creatingInvoice = false;

    public creatingManualInvoice = false;

    constructor(
        private orderhead: OrderheadService,
        private modal: ModalService,
        private state: StateService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) public navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async createInvoice() {
        if (!this.get) return;

        try {
            this.creatingInvoice = true;

            const { errorcode, errormessage, invoice_no } = await this.orderhead.createInvoice(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                if (this.get.setting_goto_invoicehead === '1' && invoice_no) {
                    if (!!this.navigator) {
                        this.navigator?.go({ to: 'invoicehead', parms: { invoice_no } });
                    } else {
                        this.state.go('invoicehead', { invoice_no });
                    }
                } else {
                    this.navigator?.back();
                }

                this.submit.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.creatingInvoice = false;
        }
    }

    public async createManualInvoice() {
        if (!this.get) return;

        try {
            this.creatingManualInvoice = true;

            const { errorcode, errormessage, invoice_no } = await this.orderhead.createManualInvoice({ ...this.get, records: this.grid?.gridfunc?.getAllRows().map((row) => ({ orderline_keyno: row['orderline_keyno'], invoice_quantity_now: row['invoice_quantity_now'] })) ?? [] });

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                if (this.get.setting_goto_invoicehead === '1' && invoice_no) {
                    if (!!this.navigator) {
                        this.navigator?.go({ to: 'invoicehead', parms: { invoice_no } });
                    } else {
                        this.state.go('invoicehead', { invoice_no });
                    }
                } else {
                    this.navigator?.back();
                }

                this.submit.emit();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.creatingManualInvoice = false;
        }
    }

    public readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_orderheadmi_invoice_now_grid').setLoadDataFunction({ method: 2916, parameters: () => this.get });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.orderhead.getOrderHeadMi(this.params);
        }
    }

    private async init() {
        await this.loadGet();
        this.readGrid();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: 'min(160rem, 98vw)', height: '95vh' });
            this.navigator.setHeading?.('p2_m_orderheadmi', true);
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params'] && !!changes['params'].currentValue) {
            this.init();
        }
    }
}
